// Topo-rail — moves an amber dot along a vertical line on the left edge
// in lockstep with the page's scroll progress. Mirrors the hero's
// "navigator dot" motif so the cartographer metaphor carries through
// the whole page.

export function initTopoRail() {
    const dot = document.querySelector(".topo-rail__dot");
    if (!dot) return;

    // Honour reduced motion — leave the dot at top, no scroll-tracking.
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (mq.matches) return;

    let ticking = false;

    function update() {
        const docH = document.documentElement.scrollHeight - window.innerHeight;
        const pct = docH > 0 ? Math.max(0, Math.min(1, window.scrollY / docH)) : 0;
        dot.style.top = pct * 100 + "%";
        ticking = false;
    }

    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    update();
}
